import { makeRequest, toCorrectFormDataValue, } from '@/js/libs/api';
import * as Types from './types';
import { encodeBody, fromDateType as fromDate, toDateType as toDate, fromDateTimeType as fromDateTime, toDateTimeUnixType as toDateTime, } from '@/js/libs/api-helpers';
export { fromDate, toDate, fromDateTime, toDateTime };
export var ChannelInline;
(function (ChannelInline) {
    ChannelInline["POSTADVERTISING"] = "POSTADVERTISING";
    ChannelInline["REACH"] = "REACH";
})(ChannelInline || (ChannelInline = {}));
export var LanguageInline;
(function (LanguageInline) {
    LanguageInline["DE"] = "DE";
    LanguageInline["EN"] = "EN";
    LanguageInline["FR"] = "FR";
    LanguageInline["IT"] = "IT";
})(LanguageInline || (LanguageInline = {}));
export var FormatInline;
(function (FormatInline) {
    FormatInline["csv"] = "csv";
})(FormatInline || (FormatInline = {}));
export var AdChannelInline;
(function (AdChannelInline) {
    AdChannelInline["SCREENS_PUBLIC_TRANSPORT"] = "SCREENS_PUBLIC_TRANSPORT";
    AdChannelInline["SCREENS_CITY"] = "SCREENS_CITY";
    AdChannelInline["SCREENS_RETAIL"] = "SCREENS_RETAIL";
    AdChannelInline["SCREENS_IN_STORE"] = "SCREENS_IN_STORE";
    AdChannelInline["SCREENS_GAS_STATION"] = "SCREENS_GAS_STATION";
})(AdChannelInline || (AdChannelInline = {}));
export var TypeInline;
(function (TypeInline) {
    TypeInline["FOUR_DIGITS"] = "FOUR_DIGITS";
    TypeInline["SIX_DIGITS"] = "SIX_DIGITS";
})(TypeInline || (TypeInline = {}));
export var StateInline;
(function (StateInline) {
    StateInline["OPEN"] = "OPEN";
    StateInline["CHARGED"] = "CHARGED";
    StateInline["MANUALLY_CHARGED"] = "MANUALLY_CHARGED";
    StateInline["NOT_CREATED"] = "NOT_CREATED";
    StateInline["CANCELED"] = "CANCELED";
})(StateInline || (StateInline = {}));
/** Creates post campaign. */ export const createPostCampaign = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-post/post-campaigns';
    const pathInternal = '/api/post-campaigns';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createPostCampaign.paramsOrder = [{ type: 'body', paramName: 'form' }];
/** get filtered Post Campaigns */ export const getFilteredPostCampaigns = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.body === undefined) {
        throw new Error('Missing required body: body');
    }
    const path = '/api/ws-post/post-campaigns/filtered';
    const pathInternal = '/api/post-campaigns/filtered';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.body !== undefined) {
        body = params.body;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getFilteredPostCampaigns.paramsOrder = [{ type: 'body', paramName: 'body' }];
/** Returns a post campaign counter. */ export const getPostCampaignsCounter = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    const path = '/api/ws-post/post-campaigns/counters';
    const pathInternal = '/api/post-campaigns/counters';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountId !== undefined) {
        urlParams.append('accountId', params.accountId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPostCampaignsCounter.paramsOrder = [{ type: 'parameters' }];
/** Returns a post campaign. */ export const getPostCampaignById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-post/post-campaigns/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/post-campaigns/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPostCampaignById.paramsOrder = [{ type: 'parameters' }];
/** Updates a post campaign. */ export const updatePostCampaign = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-post/post-campaigns/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/post-campaigns/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updatePostCampaign.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Update customer invoice reference */ export const updateCustomerInvoiceReference = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-post/post-campaigns/{id}/customer-invoice-references'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/post-campaigns/{id}/customer-invoice-references'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PATCH',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCustomerInvoiceReference.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Returns dates for tasks in the specified channel (not service) depending on dates and dispatch */ export const getTasksDatesByChannel = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.forms === undefined) {
        throw new Error('Missing required body: forms');
    }
    const path = '/api/ws-post/post-campaigns/tasks/dates';
    const pathInternal = '/api/post-campaigns/tasks/dates';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.forms !== undefined) {
        body = params.forms;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getTasksDatesByChannel.paramsOrder = [{ type: 'body', paramName: 'forms' }];
/** Returns info for generating tasks for Service Product */ export const generateServiceProductTasksInfo = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-post/post-campaigns/{id}/tasks/service'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/post-campaigns/{id}/tasks/service'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
generateServiceProductTasksInfo.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Returns post campaigns owners */ export const getOwners = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-post/post-campaigns/owners';
    const pathInternal = '/api/post-campaigns/owners';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getOwners.paramsOrder = [];
/** Returns a post campaign stages. */ export const getPostCampaignStages = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-post/post-campaigns/stages';
    const pathInternal = '/api/post-campaigns/stages';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPostCampaignStages.paramsOrder = [];
/** Returns a post campaign accounting info. */ export const getAllPostCampaignAccountingInfo = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-post/post-campaigns/accounting-info';
    const pathInternal = '/api/post-campaigns/accounting-info';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAllPostCampaignAccountingInfo.paramsOrder = [];
/** Returns a post campaign info purpose list. */ export const getPostCampaignPurposes = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-post/post-campaign-info/purposes';
    const pathInternal = '/api/post-campaign-info/purposes';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPostCampaignPurposes.paramsOrder = [];
/** Creates a post campaign target group */ export const createPostCampaignTargetGroup = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-post/post-campaign-target-groups';
    const pathInternal = '/api/post-campaign-target-groups';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.newQuote : (params.newQuote ?? queryDefaults?.['newQuote']);
        if (value !== undefined) {
            urlParams.append('newQuote', value.toString());
        }
    }
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createPostCampaignTargetGroup.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Get a post campaign target group */ export const getPostCampaignTargetGroup = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-post/post-campaign-target-groups/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/post-campaign-target-groups/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPostCampaignTargetGroup.paramsOrder = [{ type: 'parameters' }];
/** Update a post campaign target group */ export const updatePostCampaignTargetGroup = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-post/post-campaign-target-groups/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/post-campaign-target-groups/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.newQuote : (params.newQuote ?? queryDefaults?.['newQuote']);
        if (value !== undefined) {
            urlParams.append('newQuote', value.toString());
        }
    }
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updatePostCampaignTargetGroup.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const changeCampaignInfo = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.info === undefined) {
        throw new Error('Missing required body: info');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/info'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/info'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.info !== undefined) {
        body = params.info;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
changeCampaignInfo.paramsOrder = [{ type: 'body', paramName: 'info' }, { type: 'parameters' }];
/** Clone Post campaign */ export const clonePostCampaign = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/clone'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/clone'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
clonePostCampaign.paramsOrder = [{ type: 'parameters' }];
/** Filter quoted ad unit details for campaign */ export const filterAdUnitDetails = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/quoted-ad-units'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/quoted-ad-units'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
filterAdUnitDetails.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const getScreenFilterTags = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/quoted-ad-units/screen-filter-tags'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/quoted-ad-units/screen-filter-tags'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getScreenFilterTags.paramsOrder = [{ type: 'parameters' }];
/** Get latest saved quote for campaign fetch status */ export const getAdUnitDetailsFetchStatus = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/ad-unit-details/status'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/ad-unit-details/status'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdUnitDetailsFetchStatus.paramsOrder = [{ type: 'parameters' }];
/** Trigger fetching ad unit details from the API */ export const triggerAdUnitDetailsFetch = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/channel-ad-unit-details/trigger'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/channel-ad-unit-details/trigger'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
triggerAdUnitDetailsFetch.paramsOrder = [{ type: 'parameters' }];
/** Get ad units */ export const getAdUnits = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/ad-units'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/ad-units'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdUnits.paramsOrder = [{ type: 'parameters' }];
/** Get all advertising units for map-view */ export const getAdUnitsForMapView = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/ad-units/map-view'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/ad-units/map-view'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdUnitsForMapView.paramsOrder = [{ type: 'parameters' }];
/** Update ad units */ export const updateAdUnits = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/channel-ad-units'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/channel-ad-units'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateAdUnits.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Get all ad unit and ad unit details summary */ export const getAdUnitAndDetailsSummary = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/ad-units-and-details/summary'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/ad-units-and-details/summary'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdUnitAndDetailsSummary.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Get aggregated online ad unit details */ export const getAggregatedOnlineAdUnitDetails = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.channel === undefined) {
        throw new Error('Missing required parameter: channel');
    }
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/aggregated-online-ad-unit-details'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/aggregated-online-ad-unit-details'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.channel !== undefined) {
        urlParams.append('channel', params.channel.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.language : (params.language ?? queryDefaults?.['language']);
        if (value !== undefined) {
            urlParams.append('language', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAggregatedOnlineAdUnitDetails.paramsOrder = [{ type: 'parameters' }];
/** Get respective filters for imported advertising units by type */ export const getAdUnitDetailsAvailableFilters = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/channel-ad-units/available-filters'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/channel-ad-units/available-filters'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.channels : (params.channels ?? queryDefaults?.['channels']);
        if (value !== undefined) {
            urlParams.append('channels', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdUnitDetailsAvailableFilters.paramsOrder = [{ type: 'parameters' }];
/** Get selected ad unit details summary */ export const getSelectedAdUnitDetailsSummary = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.unitIds === undefined) {
        throw new Error('Missing required body: unitIds');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/ad-unit-details/selection/summary'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/ad-unit-details/selection/summary'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.unitIds !== undefined) {
        body = params.unitIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSelectedAdUnitDetailsSummary.paramsOrder = [{ type: 'body', paramName: 'unitIds' }, { type: 'parameters' }];
/** Get all screen products */ export const getAllScreenProducts = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-post/screen-products';
    const pathInternal = '/api/screen-products';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAllScreenProducts.paramsOrder = [];
/** Get selected ad unit ids */ export const getSelectedAdUnitDetailIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/ad-unit-details/selection/ids'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/ad-unit-details/selection/ids'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSelectedAdUnitDetailIds.paramsOrder = [{ type: 'parameters' }];
/** Change which advertising units are selected for next funnel step */ export const selectAdUnitDetails = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/quoted-ad-units/selection'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/quoted-ad-units/selection'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false
            ? params.updatePositions
            : (params.updatePositions ?? queryDefaults?.['updatePositions']);
        if (value !== undefined) {
            urlParams.append('updatePositions', value.toString());
        }
    }
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
selectAdUnitDetails.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Reset advertising units selection */ export const resetAdUnitDetailsSelection = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/quoted-ad-units/selection'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/quoted-ad-units/selection'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false
            ? params.updatePositions
            : (params.updatePositions ?? queryDefaults?.['updatePositions']);
        if (value !== undefined) {
            urlParams.append('updatePositions', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.types : (params.types ?? queryDefaults?.['types']);
        if (value !== undefined) {
            urlParams.append('types', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.language : (params.language ?? queryDefaults?.['language']);
        if (value !== undefined) {
            urlParams.append('language', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
resetAdUnitDetailsSelection.paramsOrder = [{ type: 'parameters' }];
/** Export quoted ad units */ export const exportAdUnitsFormattedFile = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.format === undefined) {
        throw new Error('Missing required parameter: format');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/quoted-ad-units/{format}'
        .replace('{campaignId}', params.campaignId?.toString())
        .replace('{format}', params.format?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/quoted-ad-units/{format}'
        .replace('{campaignId}', params.campaignId?.toString())
        .replace('{format}', params.format?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/octet-stream';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'blob',
        requestType: 'json',
    });
};
exportAdUnitsFormattedFile.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Get all advertising units for map-view */ export const getAdUnitDetailsForMapView = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/quoted-ad-units/map-view'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/quoted-ad-units/map-view'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdUnitDetailsForMapView.paramsOrder = [{ type: 'parameters' }];
/** Get list of discount positions */ export const getDiscountPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/discount/positions'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/discount/positions'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDiscountPositions.paramsOrder = [{ type: 'parameters' }];
/** Modify or delete or create Discount positions */ export const modifyOrCreateDiscountPosition = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.forms === undefined) {
        throw new Error('Missing required body: forms');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/discount/positions'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/discount/positions'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.forms !== undefined) {
        body = params.forms;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PATCH',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
modifyOrCreateDiscountPosition.paramsOrder = [{ type: 'body', paramName: 'forms' }, { type: 'parameters' }];
/** Get list of digital positions */ export const getDigitalPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/digital/positions'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/digital/positions'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDigitalPositions.paramsOrder = [{ type: 'parameters' }];
/** Calculate digital positions summary */ export const calculateDigitalPositionsSummary = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.forms === undefined) {
        throw new Error('Missing required body: forms');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/digital/positions'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/digital/positions'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.forms !== undefined) {
        body = params.forms;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
calculateDigitalPositionsSummary.paramsOrder = [{ type: 'body', paramName: 'forms' }, { type: 'parameters' }];
/** Upsert or delete digital positions */ export const upsertOrDeleteDigitalPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.forms === undefined) {
        throw new Error('Missing required body: forms');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/digital/positions'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/digital/positions'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.forms !== undefined) {
        body = params.forms;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PATCH',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
upsertOrDeleteDigitalPositions.paramsOrder = [{ type: 'body', paramName: 'forms' }, { type: 'parameters' }];
/** Get list of email positions */ export const getAddressedMailingPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/addressed-mailing/positions'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/addressed-mailing/positions'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAddressedMailingPositions.paramsOrder = [{ type: 'parameters' }];
/** Modify or delete addressed mailing positions */ export const modifyAddressedMailingPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.forms === undefined) {
        throw new Error('Missing required body: forms');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/addressed-mailing/positions'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/addressed-mailing/positions'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.forms !== undefined) {
        body = params.forms;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PATCH',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
modifyAddressedMailingPositions.paramsOrder = [{ type: 'body', paramName: 'forms' }, { type: 'parameters' }];
export const reconcileOnlinePositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/positions/online/reconcile'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/positions/online/reconcile'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PATCH',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
reconcileOnlinePositions.paramsOrder = [{ type: 'parameters' }];
export const reconcileAddressedMailingPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/positions/addressed-mailing/reconcile'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/positions/addressed-mailing/reconcile'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PATCH',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
reconcileAddressedMailingPositions.paramsOrder = [{ type: 'parameters' }];
/** Get list of email positions */ export const getEmailPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/email/positions'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/email/positions'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getEmailPositions.paramsOrder = [{ type: 'parameters' }];
/** Modify or delete email positions */ export const modifyEmailPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.forms === undefined) {
        throw new Error('Missing required body: forms');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/email/positions'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/email/positions'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.forms !== undefined) {
        body = params.forms;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PATCH',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
modifyEmailPositions.paramsOrder = [{ type: 'body', paramName: 'forms' }, { type: 'parameters' }];
export const reconcileEmailPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/positions/email/reconcile'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/positions/email/reconcile'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PATCH',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
reconcileEmailPositions.paramsOrder = [{ type: 'parameters' }];
export const reconcileDigitalPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.digitalNotificationRequired === undefined) {
        throw new Error('Missing required parameter: digitalNotificationRequired');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/positions/digital/reconcile'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/positions/digital/reconcile'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.digitalNotificationRequired !== undefined) {
        urlParams.append('digitalNotificationRequired', params.digitalNotificationRequired.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PATCH',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
reconcileDigitalPositions.paramsOrder = [{ type: 'parameters' }];
/** Unaddressed mailing position */ export const getMailingPosition = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/positions/mailing'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/positions/mailing'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getMailingPosition.paramsOrder = [{ type: 'parameters' }];
/** Modify mailing position */ export const modifyMailingPosition = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.forms === undefined) {
        throw new Error('Missing required body: forms');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/positions/mailing'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/positions/mailing'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.forms !== undefined) {
        body = params.forms;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PATCH',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
modifyMailingPosition.paramsOrder = [{ type: 'body', paramName: 'forms' }, { type: 'parameters' }];
export const reconcileMailingPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/positions/mailing/reconcile'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/positions/mailing/reconcile'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PATCH',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
reconcileMailingPositions.paramsOrder = [{ type: 'parameters' }];
/** Returns mailing drop-off points */ export const getMailingDropOffPoints = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-post/post-campaigns/positions/mailing/drop-off-points';
    const pathInternal = '/api/post-campaigns/positions/mailing/drop-off-points';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getMailingDropOffPoints.paramsOrder = [{ type: 'body', paramName: 'form' }];
/** Service positions */ export const getServicePositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/service/positions'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/service/positions'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getServicePositions.paramsOrder = [{ type: 'parameters' }];
/** Modify service positions */ export const modifyServicePositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.forms === undefined) {
        throw new Error('Missing required body: forms');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/service/positions'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/service/positions'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.forms !== undefined) {
        body = params.forms;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PATCH',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
modifyServicePositions.paramsOrder = [{ type: 'body', paramName: 'forms' }, { type: 'parameters' }];
/** Calculate gross unit price for a service position within a campaign (no persistence) */ export const calculateServicePositionGross = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.serviceProductId === undefined) {
        throw new Error('Missing required parameter: serviceProductId');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/service/positions/price'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/service/positions/price'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.serviceProductId !== undefined) {
        urlParams.append('serviceProductId', params.serviceProductId.toString());
    }
    {
        const value = queryDefaults === false
            ? params.percentageDiscount
            : (params.percentageDiscount ?? queryDefaults?.['percentageDiscount']);
        if (value !== undefined) {
            urlParams.append('percentageDiscount', value.toString());
        }
    }
    if (params.unsavedPositions !== undefined) {
        body = params.unsavedPositions;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
calculateServicePositionGross.paramsOrder = [
    { type: 'body', paramName: 'unsavedPositions' },
    { type: 'parameters' },
];
/** Get list of online positions */ export const getOnlinePositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/online/positions'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/online/positions'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getOnlinePositions.paramsOrder = [{ type: 'parameters' }];
/** Modify or delete online position */ export const modifyOnlinePosition = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.forms === undefined) {
        throw new Error('Missing required body: forms');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/online/positions'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/online/positions'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.forms !== undefined) {
        body = params.forms;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PATCH',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
modifyOnlinePosition.paramsOrder = [{ type: 'body', paramName: 'forms' }, { type: 'parameters' }];
export const getCampaignPositionsSummary = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/positions/summary'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/positions/summary'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositionsSummary.paramsOrder = [{ type: 'parameters' }];
export const getCampaignPositionsEmailsSummary = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.forms === undefined) {
        throw new Error('Missing required body: forms');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/positions/emails/summary'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/positions/emails/summary'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.forms !== undefined) {
        body = params.forms;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositionsEmailsSummary.paramsOrder = [{ type: 'body', paramName: 'forms' }, { type: 'parameters' }];
export const getCampaignPositionsOnlineSummary = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.forms === undefined) {
        throw new Error('Missing required body: forms');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/positions/online/summary'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/positions/online/summary'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.forms !== undefined) {
        body = params.forms;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositionsOnlineSummary.paramsOrder = [{ type: 'body', paramName: 'forms' }, { type: 'parameters' }];
export const getCampaignPositionsAddressedMailingSummary = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.forms === undefined) {
        throw new Error('Missing required body: forms');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/positions/addressed-mailing/summary'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/positions/addressed-mailing/summary'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.forms !== undefined) {
        body = params.forms;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositionsAddressedMailingSummary.paramsOrder = [
    { type: 'body', paramName: 'forms' },
    { type: 'parameters' },
];
/** Accept campaign */ export const acceptPostCampaign = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/accept'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/accept'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PATCH',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
acceptPostCampaign.paramsOrder = [{ type: 'parameters' }];
/** Decline campaign */ export const declinePostCampaign = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.reasonForRefusal === undefined) {
        throw new Error('Missing required parameter: reasonForRefusal');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/decline'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/decline'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.reasonForRefusal !== undefined) {
        urlParams.append('reasonForRefusal', params.reasonForRefusal.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PATCH',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
declinePostCampaign.paramsOrder = [{ type: 'parameters' }];
export const getDigitalAdPressures = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.adChannel === undefined) {
        throw new Error('Missing required parameter: adChannel');
    }
    const path = '/api/ws-post/positions/digital/ad-pressures/{adChannel}'.replace('{adChannel}', params.adChannel?.toString());
    const pathInternal = '/api/positions/digital/ad-pressures/{adChannel}'.replace('{adChannel}', params.adChannel?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDigitalAdPressures.paramsOrder = [{ type: 'parameters' }];
export const getDigitalAdPressuresByProductId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.productId === undefined) {
        throw new Error('Missing required parameter: productId');
    }
    const path = '/api/ws-post/positions/digital/ad-pressures/product/{productId}'.replace('{productId}', params.productId?.toString());
    const pathInternal = '/api/positions/digital/ad-pressures/product/{productId}'.replace('{productId}', params.productId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDigitalAdPressuresByProductId.paramsOrder = [{ type: 'parameters' }];
export const getTimeSlots = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-post/positions/digital/time-slots';
    const pathInternal = '/api/positions/digital/time-slots';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getTimeSlots.paramsOrder = [];
export const getDeliveryDate = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.distributionDate === undefined) {
        throw new Error('Missing required parameter: distributionDate');
    }
    const path = '/api/ws-post/positions/mailing/delivery-date';
    const pathInternal = '/api/positions/mailing/delivery-date';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.distributionDate !== undefined) {
        urlParams.append('distributionDate', params.distributionDate.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDeliveryDate.paramsOrder = [{ type: 'parameters' }];
export const getDocuments = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/documents'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/documents'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDocuments.paramsOrder = [{ type: 'parameters' }];
/** Create document from ws-file-uploader file */ export const createDocument = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/documents/create'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/documents/create'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createDocument.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Marks selected document as deleted */ export const deleteDocument = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.documentId === undefined) {
        throw new Error('Missing required parameter: documentId');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/documents/{documentId}'
        .replace('{campaignId}', params.campaignId?.toString())
        .replace('{documentId}', params.documentId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/documents/{documentId}'
        .replace('{campaignId}', params.campaignId?.toString())
        .replace('{documentId}', params.documentId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
deleteDocument.paramsOrder = [{ type: 'parameters' }];
/** Returns the Document in Base64 format. */ export const downloadDocumentFile = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.documentId === undefined) {
        throw new Error('Missing required parameter: documentId');
    }
    const path = '/api/ws-post/post-campaigns/{campaignId}/documents/{documentId}/download'
        .replace('{campaignId}', params.campaignId?.toString())
        .replace('{documentId}', params.documentId?.toString());
    const pathInternal = '/api/post-campaigns/{campaignId}/documents/{documentId}/download'
        .replace('{campaignId}', params.campaignId?.toString())
        .replace('{documentId}', params.documentId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: { 200: 'json', 204: 'json' },
        requestType: 'json',
    });
};
downloadDocumentFile.paramsOrder = [{ type: 'parameters' }];
/** Returns campaigns for reporting */ export const getReportingPostCampaigns = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-post/reporting/post-campaigns';
    const pathInternal = '/api/reporting/post-campaigns';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getReportingPostCampaigns.paramsOrder = [{ type: 'parameters' }];
/** Get place names */ export const getPlacenames = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-post/geo/lookup/placenames';
    const pathInternal = '/api/geo/lookup/placenames';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPlacenames.paramsOrder = [{ type: 'parameters' }];
/** Get post codes */ export const getPostCodes = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.filter === undefined) {
        throw new Error('Missing required parameter: filter');
    }
    const path = '/api/ws-post/geo/lookup/post-codes';
    const pathInternal = '/api/geo/lookup/post-codes';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    if (params.filter !== undefined) {
        urlParams.append('filter', params.filter.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPostCodes.paramsOrder = [{ type: 'parameters' }];
/** Lookup address */ export const getAddresses = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-post/geo/lookup/addresses';
    const pathInternal = '/api/geo/lookup/addresses';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.searchQuery : (params.searchQuery ?? queryDefaults?.['searchQuery']);
        if (value !== undefined) {
            urlParams.append('searchQuery', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAddresses.paramsOrder = [{ type: 'parameters' }];
/** Download postcodes template file */ export const downloadPostalCodesTemplateFile = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.type === undefined) {
        throw new Error('Missing required parameter: type');
    }
    const path = '/api/ws-post/geo/postcodes/templates';
    const pathInternal = '/api/geo/postcodes/templates';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.type !== undefined) {
        urlParams.append('type', params.type.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/octet-stream';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'blob',
        requestType: 'json',
    });
};
downloadPostalCodesTemplateFile.paramsOrder = [{ type: 'parameters' }];
/** Link an uploaded postal codes file from ws-file-uploader */ export const linkPostalCodesFile = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-post/geo/postcodes/link';
    const pathInternal = '/api/geo/postcodes/link';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
linkPostalCodesFile.paramsOrder = [{ type: 'body', paramName: 'form' }];
/** Get All postalCode areas Geometry Data */ export const getAllBoundaries = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-post/geo/switzerland/postalcodes/boundaries';
    const pathInternal = '/api/geo/switzerland/postalcodes/boundaries';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAllBoundaries.paramsOrder = [];
/** Get filtered service products */ export const getServiceProducts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.postCampaignId === undefined) {
        throw new Error('Missing required parameter: postCampaignId');
    }
    const path = '/api/ws-post/positions/service/products';
    const pathInternal = '/api/positions/service/products';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.postCampaignId !== undefined) {
        urlParams.append('postCampaignId', params.postCampaignId.toString());
    }
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getServiceProducts.paramsOrder = [{ type: 'parameters' }];
/** Calculate netAmount */ export const calculateNetAmount = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.grossUnitPrice === undefined) {
        throw new Error('Missing required parameter: grossUnitPrice');
    }
    if (params.percentageDiscount === undefined) {
        throw new Error('Missing required parameter: percentageDiscount');
    }
    const path = '/api/ws-post/positions/netAmount';
    const pathInternal = '/api/positions/netAmount';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.grossUnitPrice !== undefined) {
        urlParams.append('grossUnitPrice', params.grossUnitPrice.toString());
    }
    {
        const value = queryDefaults === false ? params.quantity : (params.quantity ?? queryDefaults?.['quantity']);
        if (value !== undefined) {
            urlParams.append('quantity', value.toString());
        }
    }
    if (params.percentageDiscount !== undefined) {
        urlParams.append('percentageDiscount', params.percentageDiscount.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
calculateNetAmount.paramsOrder = [{ type: 'parameters' }];
/** Returns preview html. */ export const getHtmlOfferPreview = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-post/post-campaigns/{id}/offer/preview'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/post-campaigns/{id}/offer/preview'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.language : (params.language ?? queryDefaults?.['language']);
        if (value !== undefined) {
            urlParams.append('language', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.isDetailed : (params.isDetailed ?? queryDefaults?.['isDetailed']);
        if (value !== undefined) {
            urlParams.append('isDetailed', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'text/html';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'text',
        requestType: 'json',
    });
};
getHtmlOfferPreview.paramsOrder = [{ type: 'parameters' }];
/** Returns created document for campaign. */ export const createPdfOfferDocument = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-post/post-campaigns/{id}/documents/offer/generate'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/post-campaigns/{id}/documents/offer/generate'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.language : (params.language ?? queryDefaults?.['language']);
        if (value !== undefined) {
            urlParams.append('language', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.isDetailed : (params.isDetailed ?? queryDefaults?.['isDetailed']);
        if (value !== undefined) {
            urlParams.append('isDetailed', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createPdfOfferDocument.paramsOrder = [{ type: 'parameters' }];
/** Returns created invoice document name for campaign. */ export const createPdfInvoiceDocument = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.invoiceId === undefined) {
        throw new Error('Missing required parameter: invoiceId');
    }
    const path = '/api/ws-post/post-campaigns/{id}/documents/invoices/{invoiceId}/generate'
        .replace('{id}', params.id?.toString())
        .replace('{invoiceId}', params.invoiceId?.toString());
    const pathInternal = '/api/post-campaigns/{id}/documents/invoices/{invoiceId}/generate'
        .replace('{id}', params.id?.toString())
        .replace('{invoiceId}', params.invoiceId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.language : (params.language ?? queryDefaults?.['language']);
        if (value !== undefined) {
            urlParams.append('language', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createPdfInvoiceDocument.paramsOrder = [{ type: 'parameters' }];
/** Returns html preview for tasks timetable. */ export const getTasksTimeTableHtmlPreview = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-post/post-campaigns/{id}/tasks/timetable/preview'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/post-campaigns/{id}/tasks/timetable/preview'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.language : (params.language ?? queryDefaults?.['language']);
        if (value !== undefined) {
            urlParams.append('language', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'text/html';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'text',
        requestType: 'json',
    });
};
getTasksTimeTableHtmlPreview.paramsOrder = [{ type: 'parameters' }];
/** Returns created timetable xlsx document */ export const createTasksTimeTableXlsxDocument = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-post/post-campaigns/{id}/tasks/timetable/generate'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/post-campaigns/{id}/tasks/timetable/generate'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.language : (params.language ?? queryDefaults?.['language']);
        if (value !== undefined) {
            urlParams.append('language', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createTasksTimeTableXlsxDocument.paramsOrder = [{ type: 'parameters' }];
/** Returns created briefing document */ export const createBriefingEmlDocument = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-post/post-campaigns/{id}/documents/briefing/generate'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/post-campaigns/{id}/documents/briefing/generate'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.language : (params.language ?? queryDefaults?.['language']);
        if (value !== undefined) {
            urlParams.append('language', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createBriefingEmlDocument.paramsOrder = [{ type: 'parameters' }];
/** Replace old account id with new one. */ export const replaceAccountId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    if (params.newAccountId === undefined) {
        throw new Error('Missing required parameter: newAccountId');
    }
    const path = '/api/ws-post/accounts/replace-account-id';
    const pathInternal = '/api/accounts/replace-account-id';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountId !== undefined) {
        urlParams.append('accountId', params.accountId.toString());
    }
    if (params.newAccountId !== undefined) {
        urlParams.append('newAccountId', params.newAccountId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
replaceAccountId.paramsOrder = [{ type: 'parameters' }];
/** Get revenue by account grouped by year */ export const getAccountYearlyRevenue = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-post/accounts/{id}/yearly_revenue'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/accounts/{id}/yearly_revenue'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAccountYearlyRevenue.paramsOrder = [{ type: 'parameters' }];
/** Get list of invoices */ export const getInvoices = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    if (params.state === undefined) {
        throw new Error('Missing required parameter: state');
    }
    const path = '/api/ws-post/invoices';
    const pathInternal = '/api/invoices';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.searchQuery : (params.searchQuery ?? queryDefaults?.['searchQuery']);
        if (value !== undefined) {
            urlParams.append('searchQuery', value.toString());
        }
    }
    if (params.state !== undefined) {
        urlParams.append('state', params.state.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getInvoices.paramsOrder = [{ type: 'parameters' }];
/** Charge or charge manually invoice */ export const chargeInvoice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.invoice === undefined) {
        throw new Error('Missing required body: invoice');
    }
    const path = '/api/ws-post/invoices/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/invoices/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.invoice !== undefined) {
        body = params.invoice;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PATCH',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
chargeInvoice.paramsOrder = [{ type: 'body', paramName: 'invoice' }, { type: 'parameters' }];
/** Update invoice position */ export const updateInvoicePosition = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.positionId === undefined) {
        throw new Error('Missing required parameter: positionId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-post/invoices/{id}/positions/{positionId}'
        .replace('{id}', params.id?.toString())
        .replace('{positionId}', params.positionId?.toString());
    const pathInternal = '/api/invoices/{id}/positions/{positionId}'
        .replace('{id}', params.id?.toString())
        .replace('{positionId}', params.positionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateInvoicePosition.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Reset invoice position */ export const resetInvoicePosition = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.positionId === undefined) {
        throw new Error('Missing required parameter: positionId');
    }
    const path = '/api/ws-post/invoices/{id}/positions/{positionId}'
        .replace('{id}', params.id?.toString())
        .replace('{positionId}', params.positionId?.toString());
    const pathInternal = '/api/invoices/{id}/positions/{positionId}'
        .replace('{id}', params.id?.toString())
        .replace('{positionId}', params.positionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PATCH',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
resetInvoicePosition.paramsOrder = [{ type: 'parameters' }];
/** Get invoice state by post campaign id */ export const getInvoiceState = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.postCampaignId === undefined) {
        throw new Error('Missing required parameter: postCampaignId');
    }
    const path = '/api/ws-post/invoices/state/{postCampaignId}'.replace('{postCampaignId}', params.postCampaignId?.toString());
    const pathInternal = '/api/invoices/state/{postCampaignId}'.replace('{postCampaignId}', params.postCampaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getInvoiceState.paramsOrder = [{ type: 'parameters' }];
/** Cancel or reopen an invoice */ export const cancelOrReopenInvoice = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.body === undefined) {
        throw new Error('Missing required body: body');
    }
    const path = '/api/ws-post/invoices/{id}/state'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/invoices/{id}/state'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.body !== undefined) {
        body = params.body;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PATCH',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
cancelOrReopenInvoice.paramsOrder = [{ type: 'body', paramName: 'body' }, { type: 'parameters' }];
/** Returns media sort order */ export const getMediaSortOrder = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.postCampaignId === undefined) {
        throw new Error('Missing required parameter: postCampaignId');
    }
    const path = '/api/ws-post/post-campaigns/{postCampaignId}/media-sort-order'.replace('{postCampaignId}', params.postCampaignId?.toString());
    const pathInternal = '/api/post-campaigns/{postCampaignId}/media-sort-order'.replace('{postCampaignId}', params.postCampaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getMediaSortOrder.paramsOrder = [{ type: 'parameters' }];
/** Update media sort order */ export const updateMediaSortOrder = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.postCampaignId === undefined) {
        throw new Error('Missing required parameter: postCampaignId');
    }
    if (params.mediaSortTypes === undefined) {
        throw new Error('Missing required body: mediaSortTypes');
    }
    const path = '/api/ws-post/post-campaigns/{postCampaignId}/media-sort-order'.replace('{postCampaignId}', params.postCampaignId?.toString());
    const pathInternal = '/api/post-campaigns/{postCampaignId}/media-sort-order'.replace('{postCampaignId}', params.postCampaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.mediaSortTypes !== undefined) {
        body = params.mediaSortTypes;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateMediaSortOrder.paramsOrder = [{ type: 'body', paramName: 'mediaSortTypes' }, { type: 'parameters' }];
export const getAffinities = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-post/affinities';
    const pathInternal = '/api/affinities';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAffinities.paramsOrder = [];
export * from './types';
export * from './constants';
